/***
 *
 * @file components/Iframe/index.tsx
 * @description Iframe component will be used for rendering the content.
 * @author Naveen Kumar
 * @organization Truminds Software System
 * @since 13 Feb 2024
 *
 */

import React, { EventHandler } from "react";
// import "./Iframe.scss";
import { IFRAME_CATEGORY_ID } from "@/config/app.config";

type Props = {
  title?: string,
  categoryId?: string | undefined,
  src: string,
  allowFullScreen?: boolean,
  loading?: "lazy" | "eager",
  onLoad?: any,
  allow?: string,
  className?: string,
  height?: string | undefined,
  width?: string | undefined,
  //height and width used in html renderer
}


const Iframe = ({ src, height, categoryId = "", width, allowFullScreen, allow = "clipboard-write", onLoad = () => { }, loading, title, ...props }: Props) => {
  return (
    <div className="Iframe-container" data-testid="Iframe">
      <iframe src={src} allow={allow} onLoad={onLoad} height={height} width={width} allowFullScreen={allowFullScreen} loading={loading} title={title || "iframe"} {...props} sandbox="allow-scripts allow-same-origin allow-forms"></iframe>
    </div>
  );
};

export default Iframe;
